<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  setup() {
    // setup 내용 필요 없으면 그대로 둬도 됩니다
  },
};
</script>

<style>
html, body, #app {
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  min-height: 100%;   /* 최소 높이 전체 화면 */
  overflow: auto;     /* 컨텐츠가 길면 스크롤 가능 */
}
</style>
